export const TextTestPageObject = (value: undefined | null | string) => ({
    getType: () => "Text",

    getValue: () => value,
});
